export const LOGIN = "session/LOGIN";
export const LOGIN_COMPLETED = "session/LOGIN_COMPLETED";
export const LOGIN_FAILED = "session/LOGIN_FAILED";
export const LOGOUT = "session/LOGOUT";
export const INITIALIZE = "session/INITIALIZE_SESSION";
export const GET_ESTABLISHMENT = "session/GET_ESTABLISHMENT";
export const TOKEN_REFRESHED = "session/TOKEN_REFRESHED";
